import heroVideoMobile from "../../assets/BackgroundMovies/hero_movie_354x560.mp4";
import heroVideoTablet from "../../assets/BackgroundMovies/hero_movie_1280x600.mp4";
import heroVideoDesktop from "../../assets/BackgroundMovies/hero_movie_1280x800.mp4";
import heroPosterMobile from "../../assets/BackgroundMovies/hero_poster_354x560.jpg";
import heroPosterTablet from "../../assets/BackgroundMovies/hero_poster_1280x600.jpg";
import heroPosterDesktop from "../../assets/BackgroundMovies/hero_poster_1280x800.jpg";

export enum VideoBreakpoint {
  Mobile = 0,
  Tablet = 1,
  Desktop = 2,
}

export const videoSources: Record<VideoBreakpoint, string> = {
  [VideoBreakpoint.Mobile]: heroVideoMobile,
  [VideoBreakpoint.Tablet]: heroVideoTablet,
  [VideoBreakpoint.Desktop]: heroVideoDesktop,
};

export const posterSources: Record<VideoBreakpoint, string> = {
  [VideoBreakpoint.Mobile]: heroPosterMobile,
  [VideoBreakpoint.Tablet]: heroPosterTablet,
  [VideoBreakpoint.Desktop]: heroPosterDesktop,
};

export const heroTitle = "CERN Expertise and";

export const heroSubtitle = "Real-World AI Solutions";
